import React, { useState } from 'react';
import { SnapDialog, Button, TextField } from '@one-snap/sparkles';
import PropTypes from 'prop-types';
import './AwarenessPageStyles.css';
import Footbar from './Footbar';
import CartAmountHeader from './CartAmountHeader';

function MobilePage({ isVisible, onClose, onContinue, totalAmount, goBack }) {
  const [phoneNumber, setPhoneNumber] = useState('(123) 456-7890');
  const [isButtonEnabled, setIsButtonEnabled] = useState(true);

  const formatPhoneNumber = (value) => {
    if (!value) return value;

    const cleaned = value.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

    if (match) {
      const formatted = `${match[1] ? `(${match[1]}` : ''}${match[2] ? `) ${match[2]}` : ''}${match[3] ? `-${match[3]}` : ''}`;
      return formatted.trim();
    }

    return value;
  };

  const handleInputChange = (event) => {
    const rawValue = event.target.value;
    const formattedValue = formatPhoneNumber(rawValue);

    setPhoneNumber(formattedValue);

    const cleaned = formattedValue.replace(/\D/g, '');
    setIsButtonEnabled(cleaned.length === 10);
  };

  const handleContinue = () => {
    onContinue(phoneNumber);
  };

  return (
    <SnapDialog open={isVisible} onClose={onClose} maxWidth="sm">
      <div className="awareness-page">
        <CartAmountHeader
          totalAmount={totalAmount}
          goBack={goBack}
          showCartAmount
        />
        <div className="awareness-content">
          <div className="awareness-title">
            Snap Finance is a lease-to-own financing provider, helping
            credit-challenged customers.<sup>1</sup>
          </div>
          <div className="lto-mobile-header-2">
            Minimum invoice amount $150. Approvals up to $5,000.<sup>2</sup>
          </div>
          <br />
          <div className="lto-mob-application-start">
            <div className="lto-mobile-header-3">
              Start or resume an application here
            </div>
            <TextField
              label="Mobile Phone Number"
              className="mobile-input"
              fullWidth
              value={phoneNumber}
              onChange={handleInputChange}
              inputProps={{ maxLength: 14 }}
            />
            <Button
              className="continue-button"
              onClick={handleContinue}
              disabled={!isButtonEnabled}
            >
              Continue
            </Button>
          </div>
          <br />
          <div className="description-section">
            <div>
              <span className="lto-mob-txt-left">Simple.</span>
              <span className="lto-mob-txt-right">
                Easy to apply, know in seconds.
              </span>
            </div>
            <br />
            <div>
              <span className="lto-mob-txt-left">Accessible.</span>
              <span className="lto-mob-txt-right">
                For those who need it most.
              </span>
            </div>
            <br />
            <div>
              <span className="lto-mob-txt-left">Flexible.</span>
              <span className="lto-mob-txt-right">
                Get it now, pay over time.<sup>3</sup>
              </span>
            </div>
          </div>
          <br />
          <br />
          <br />
          <div className="lto-mob-script">
            <p>
              The lease-to-own agreement offered by Snap RTO LLC is a financing
              option not available to residents of Minnesota, New Jersey, and
              Wisconsin.
            </p>
            <ol>
              <li>
                While no credit history is required, Snap obtains information
                from consumer reporting agencies in connection with the
                lease-to-own application. Not all applicants are approved.
              </li>
              <li>
                As of February, 2023, the average approval amount a customer
                receives is $2,900.
              </li>
              <li>
                Standard lease-to-own terms renew for a maximum of 12-18 months.
                The agreement includes a Cost of Lease above the cost of the
                merchandise. To exercise one of our early ownership options,
                customers must call Snap Customer Care at 877-557-3769 and then
                complete all payments within the contracted number of days.
                Learn more by chatting with us.
              </li>
            </ol>
            <p>
              Some restrictions on leasable auto parts may apply. See merchants
              for restrictions.
            </p>
          </div>
          <Footbar />
        </div>
      </div>
    </SnapDialog>
  );
}

MobilePage.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  totalAmount: PropTypes.string.isRequired
};

export default MobilePage;
